import { Box } from '@mui/material';
import lexoAnimatedLogo from '@/assets/icons/lexo-animated-logo.svg';

export default function FullScreenLoader() {
    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'fixed',
                top: 0,
                left: 0,
                height: '100vh',
                width: '100vw',
                backgroundColor: 'rgba(0,0,0,0.5)',
                color: 'white',
                zIndex: 9999,
            }}
        >
            <h4 style={{ textAlign: 'center' }}>
                <img
                    style={{
                        width: '50px',
                    }}
                    src={lexoAnimatedLogo}
                    alt=""
                />
            </h4>
        </Box>
    );
}
